import {
  CommonRequest,
  Method,
  ServiceName,
  CommonResponse,
  DmlResponse,
} from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { EmailMaster } from 'models/common/Email';

export const saveSendMailInfo = async (saveData: EmailMaster[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/email/sendMailInfo`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: saveData,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as DmlResponse;
};
